import { Box } from "@mui/material"
import useAppStore from "store/app"

const BodyPart = (props) => {
  const { bodyPartId, children } = props

  const id = bodyPartId[0]

  // const { selected } = useAppStore((state) => state.anamnesis)
  const handleSelect = useAppStore((state) => state.bodyPartSelect)
  const toggleDrawer = useAppStore((state) => state.toggleDrawer)

  const handleClick = () => {
    handleSelect(id)
    toggleDrawer(true)
  }

  return (
    <Box
      component="g"
      onClick={handleClick}
      // selected={selected === id}
      sx={{
        path: {
          fill: "#31a7ff",
          // opacity: selected === id ? 0.5 : 0,
          opacity: 0,
          cursor: "pointer",
        },

        "&:hover path": {
          opacity: 0.5,
        },
      }}
    >
      {children}
    </Box>
  )
}

export default BodyPart
